// removed by extract-text-webpack-plugin
module.exports = {"block":"_1AIPEyxuLgqDBZMQfSj04j","zebra":"_2xqMxwhGIMQj0A8OkgV6CO","yellow":"_3Bvj2Ary4Ppgx6TOlFuDZE","darkgray":"vC5hmV6ieO9l24h5nPy3D","lightgray":"LAWPGLeETWziyGSyvTn5k","white":"_2q_KBOiApRbIU_8nV_lzH6","heading":"_2JSbVOWOZ0wGeFYmv13zan"};


//////////////////
// WEBPACK FOOTER
// ./src/hoc/Block/Block.module.scss
// module id = 821
// module chunks = 0